import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const CaptionStyle: React.CSSProperties = {
    fontFamily: 'Segoe UI',
    fontSize: '0.8rem',
    fontWeight: 500,
    color: 'rgba(0,0,0,0.8)',
    textTransform: 'uppercase',
};

export const Caption = styled('span', CaptionStyle);



// WEBPACK FOOTER //
// ./primitives/Caption.tsx